import { useMemo } from "react";
import {
  ValidatedInfo,
  ValidatingInfo,
} from "../../../reporting/report-lists/reports/copyto/CompanyMultipleReportsListItemContainer.tsx";
import type { SelectedCompanyDashboard } from "../../hooks/validationStateSlice";

interface DashboardSummaryProps {
  dashboard: SelectedCompanyDashboard;
}

export const DashboardSummary = ({ dashboard }: DashboardSummaryProps) => {
  const isValidating = useMemo(() => dashboard.tiles.some((t) => t.validating), [dashboard.tiles]);
  const items = useMemo(() => dashboard.tiles, [dashboard.tiles]);

  return isValidating ? <ValidatingInfo items={items} /> : <ValidatedInfo items={items} />;
};
